import getTitle from 'helpers/getTitle'
import Translate from 'modules/local/Translate'
import React from 'react'
import {NullAsDefault} from 'views/Shared'
import {AiOutlineRight} from "react-icons/ai";
import _ from "lodash"
import {BsFolder} from "react-icons/bs";

export const renderSubCategory =
    ({renderContextMenu = NullAsDefault} = {}) =>
        (item, index) => {
            const {description} = item || {}
            return (
                <Translate key={index}>
                    {(t) => (
                        <div className="px-3 py-2 flex flex-col gap-1 border border-color-50 shadow-md rounded-lg hover:scale-3xs custom-item-render relative">
                            <div className="flex gap-2 items-center justify-start">
                                <BsFolder className="text-color-500"/>
                                {!!_.get(item, 'parent') && (
                                    <React.Fragment>
                                        <div className="font-semibold text-sm text-color-400">
                                            {getTitle(_.get(item, 'parent'))}
                                        </div>
                                        <AiOutlineRight className="text-sm text-color-300"/>
                                    </React.Fragment>
                                )}
                                <div className="font-bold text-sm text-color-000">
                                    {getTitle(item)}
                                </div>
                            </div>
                            {description && (
                                <span className="text-xs text-color-300 tracking-wider">
                                    {description}
                                </span>
                            )}
                            {_.isFunction(renderContextMenu) && (
                                renderContextMenu(item)
                            )}
                        </div>
                    )}
                </Translate>
            )
        }
